module.exports = __webpack_public_path__ + "img/router.c58ac014.svg";